export default __webpack_public_path__ + "static/media/dashboard-text.23d9c638.svg";